<div class="pop_up">
<h5>Declaration Message:</h5>
<div><p>Dear Jury, Would you like to submit your day evaluation.</p></div>
<button mat-raised-button class="pull-left" color="primary" (click)="proceed()" [disabled]="chkev">{{dayEndTxt}}</button>
<button mat-raised-button class="pull-right" color="warn" (click)="cancel()" [disabled]="chkev">Deny</button>
</div>